import { Link } from 'react-router-dom'
import React from 'react'
import { jt, t } from 'ttag'

import withOpenMaps from '../../withOpenMaps'

const MyMapComponent = withOpenMaps(
  ({ profile, MapContainer, Marker, Popup, TileLayer }) => {
    if (!profile.latitude || !profile.longitude) {
      return null
    }

    //console.log(profile, Map, Marker, Popup, TileLayer)
    const position = [parseFloat(profile.latitude), parseFloat(profile.longitude)]
    const zoom = 11

    return (
      <div>
        <MapContainer center={position} style={{ height: '150px' }} zoom={zoom}>
          <TileLayer
            attribution='&amp;copy <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
          />
          <Marker position={position}>
            <Popup>
              <div style={{ display: 'inline-block' }}>
                <b>{profile.name}</b>
                <br />
                {profile.address} <br />
                {profile.city}, {profile.state} {profile.zipCode}
              </div>
            </Popup>
          </Marker>
        </MapContainer>
      </div>
    )
  }
)
const CollegeRecommendation = ({ recommendations }) => {
  return (
    <div className="recommendations col-sm-3">
      <h3 style={{ color: 'black' }}>{t`Top Institutions`}</h3>
      <ul className="recommendation-listing">
        {recommendations?.items?.map(r => {
          //console.log(r)
          const countHtml = <b>{r.count.toLocaleString()}</b>

          return (
            <li key={r.id}>
              <div className={`inlist-recommendation`}>
                <MyMapComponent profile={r} />
                <h3 style={{ marginTop: '10px', marginBottom: '5px' }}>{r.name}</h3>
                <div>
                  {r.address} <br />
                  {r.city}, {r.state} {r.zipCode}
                </div>
                <p
                  style={{
                    marginTop: '10px',
                    marginBottom: '5px'
                  }}>
                  {jt`${countHtml} of these programs offered`}
                </p>
                <Link to={r.url} className="btn btn-success no-style pull-right">
                  {t`View this Institution`}
                </Link>
                <br className="clear" />
              </div>
            </li>
          )
        })}
      </ul>
    </div>
  )
}

export default CollegeRecommendation
